let _warned = false;

const template = document.createElement("template");

template.innerHTML = `
<style>
  :host {
    --ctl-gap-xs: var(--ctl-space-2, 8px);
    --ctl-gap-sm: var(--ctl-space-3, 12px);
    --ctl-gap-md: var(--ctl-space-4, 16px);
    --ctl-gap-lg: var(--ctl-space-5, 24px);
    --ctl-gap-xl: var(--ctl-space-7, 48px);

    display: flex;
    flex-direction: column;
    gap: var(--_gap, var(--ctl-gap-md));
    align-items: var(--_align, stretch);
    justify-content: var(--_justify, flex-start);
    flex-wrap: var(--_wrap, nowrap);
    box-sizing: border-box;
  }

  /* gap */
  :host([gap="xs"]) { --_gap: var(--ctl-gap-xs); }
  :host([gap="sm"]) { --_gap: var(--ctl-gap-sm); }
  :host([gap="md"]) { --_gap: var(--ctl-gap-md); }
  :host([gap="lg"]) { --_gap: var(--ctl-gap-lg); }
  :host([gap="xl"]) { --_gap: var(--ctl-gap-xl); }

  /* align */
  :host([align="start"])   { --_align: flex-start; }
  :host([align="center"])  { --_align: center; }
  :host([align="end"])     { --_align: flex-end; }
  :host([align="stretch"]) { --_align: stretch; }

  /* justify */
  :host([justify="start"])   { --_justify: flex-start; }
  :host([justify="center"])  { --_justify: center; }
  :host([justify="end"])     { --_justify: flex-end; }
  :host([justify="between"]) { --_justify: space-between; }

  /* wrap */
  :host([wrap]) { --_wrap: wrap; }
</style>

<slot></slot>
`;

class CtlStack extends HTMLElement {
  static get observedAttributes() {
    return ['gap', 'align', 'justify', 'wrap'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    if (!this.hasAttribute('gap')) this.setAttribute('gap', 'md');
    if (!this.hasAttribute('align')) this.setAttribute('align', 'stretch');
    if (!this.hasAttribute('justify')) this.setAttribute('justify', 'start');

    if (!_warned) {
      _warned = true;
      console.warn(
        '[ctl-stack] is deprecated. Use the CSS utility class .ctl-stack instead.\n' +
        '  Migration: <ctl-stack gap="lg" align="center">  →  <div class="ctl-stack ctl-gap-lg ctl-align-center">\n' +
        '  See the package documentation for details on the .ctl-stack CSS utility.'
      );
    }
  }

  attributeChangedCallback() {
    // no-op: CSS does the work
  }

  get gap() { return this.getAttribute('gap') || 'md'; }
  set gap(v) { this.setAttribute('gap', String(v || 'md')); }

  get align() { return this.getAttribute('align') || 'stretch'; }
  set align(v) { this.setAttribute('align', String(v || 'stretch')); }

  get justify() { return this.getAttribute('justify') || 'start'; }
  set justify(v) { this.setAttribute('justify', String(v || 'start')); }

  get wrap() { return this.hasAttribute('wrap'); }
  set wrap(v) { v ? this.setAttribute('wrap', '') : this.removeAttribute('wrap'); }
}

customElements.define("ctl-stack", CtlStack);

export { CtlStack };
